import { useStrings } from "features/i18n/useStrings";
import { useContext } from "react";

import { LevelContext } from "./Contexts";
import "./LevelIndicator.less";
import strings from "./LevelIndicator.strings";

export function LevelIndicator({
    variant = "default",
}: {
    variant?: "circle" | "default";
}) {
    const { level, subLevel } = useContext(LevelContext);
    const t = useStrings(strings);
    return (
        <div
            className={`LevelIndicator${
                variant === "circle" ? " circled" : ""
            }`}
        >
            {subLevel === 0 ? level : t.subLevel({ level, subLevel })}
        </div>
    );
}
